import Immutable from "immutable";

// Where a view is reachable from in the App: the hamburger menu only, or the
// bottom bar as well.
export const ViewLocation = {
  menu: "menu",
  bottomBar: "bottomBar",
};

export const isViewLocation = (value) =>
  Object.values(ViewLocation).indexOf(value) >= 0;

// A custom view composed in the mobile app's DevCon. Mirrors the Dashboard model
// (a react-grid-layout `tiles` array + a keyed `data` map), plus `columns` and the
// arrangement the App reads: which views to show, in what order, and where from.
// Views belong to the device's `general.appPages` setting, not the account.
const AppPageModel = Immutable.Record({
  id: "", // stable string, created once; legacy imports keep their storage key
  name: "",
  columns: 2, // grid columns (2 | 3 | 4)
  tiles: [], // [{ i, x, y, w, h }]
  data: {}, // { [i]: { type: 'quickButton' | 'text', config: {...} } }
  enabled: true, // shown in the App at all
  position: 0, // display order on this device (always the row index)
  location: ViewLocation.menu, // ViewLocation
});

export default class AppPage extends AppPageModel {
  id: string;
  name: string;
  columns: number;
  tiles: Object[];
  data: Object;
  enabled: boolean;
  position: number;
  location: string;

  // Tile key. The random suffix stops two tiles added in the same millisecond
  // from sharing a key and overwriting each other in `data`.
  uuid() {
    return `${Date.now()}_${Math.random().toString(36).slice(2, 9)}`;
  }

  get isOnBottomBar() {
    return this.get("location") === ViewLocation.bottomBar;
  }

  // `tiles` and `data` are plain JS inside the record, so copy both — and not via
  // a scalar `set`, which returns the same instance when the value is unchanged.
  clone() {
    return this.set("tiles", [...(this.get("tiles") || [])]).set("data", {
      ...(this.get("data") || {}),
    });
  }
}
